import { render, staticRenderFns } from "./Writeoff.vue?vue&type=template&id=9650d672"
import script from "./Writeoff.vue?vue&type=script&lang=js"
export * from "./Writeoff.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports